module.exports = __webpack_public_path__ + "img/ddlogo-02.63247428.png";